import { render, staticRenderFns } from "./TableTerms.vue?vue&type=template&id=73747774&"
import script from "./TableTerms.vue?vue&type=script&lang=js&"
export * from "./TableTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports